import React from "react";
import Navbar from "./Navbar";
import Footer from "./mapcomponents/Footer";
import "./App.css";
import MapPage from "./pages/MapPage";
import Homepage from "./pages/HomePage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RoutePage from "./pages/RoutePage";
import VizPage from "./pages/VizPage";
import ModelPage from "./pages/ModelPage";
import QuizPage from "./pages/QuizPage";
import NotFound from "./pages/NotFound";
import SafetyChatbot from "./homecomponents/SafetyChatbot";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="map" element={<MapPage />} />
          <Route path="route" element={<RoutePage />} />
          <Route path="viz" element={<VizPage />} />
          <Route path="model" element={<ModelPage />} />
          <Route path="quiz" element={<QuizPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Footer className="footer" />
      <SafetyChatbot />
    </div>
  );
}

export default App;
